import { Routes, Route, Link } from 'react-router-dom'
import { Calendar, Phone } from 'lucide-react'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

// Import Pages
import Home from './pages/Home'
import About from './pages/About'
import TherapistDetail from './pages/TherapistDetail'
import Clinic from './pages/Clinic'
import Treatments from './pages/Treatments'
import TreatmentDetail from './pages/TreatmentDetail'
import NextSteps from './pages/NextSteps'
import Testimonials from './pages/Testimonials'
import RorbaekTeknikken from './pages/RorbaekTeknikken'
import FaqPage from './pages/FaqPage'
import BookingPage from './pages/BookingPage'
import ContactPage from './pages/ContactPage'

function App() {
  return (
    <div className="relative min-h-screen flex flex-col bg-[#FDFBF7] text-[#1E352F] antialiased">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      {/* Added bottom padding on mobile to prevent content from being hidden behind the sticky mobile bar */}
      <main className="flex-grow pb-20 min-[1200px]:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/om-os/:slug" element={<TherapistDetail />} />
          <Route path="/klinikken" element={<Clinic />} />
          <Route path="/behandlinger" element={<Treatments />} />
          <Route path="/behandlinger/:slug" element={<TreatmentDetail />} />
          <Route path="/rorbaek-teknikken" element={<RorbaekTeknikken />} />
          <Route path="/videre-forloeb" element={<NextSteps />} />
          <Route path="/gode-erfaringer" element={<Testimonials />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/bestil-tid" element={<BookingPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          {/* Fallback to Home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />

      {/* Sticky Mobile Booking Bar (< 1200px) */}
      <div className="min-[1200px]:hidden fixed bottom-0 left-0 right-0 bg-[#1E352F] text-[#F5F0E6] border-t border-[#2D4A43] py-3 px-4 shadow-2xl z-40 flex items-center justify-between animate-in slide-in-from-bottom duration-300">
        <div className="flex flex-col">
          <span className="text-xs font-serif font-bold tracking-wide">Rørbækklinikken</span>
          <a
            href="tel:86639393"
            className="text-[10px] text-[#F5F0E6]/70 hover:text-white transition-colors flex items-center gap-1"
          >
            <Phone className="w-3 h-3 text-[#eebb53]" />
            86 63 93 93
          </a>
        </div>
        <Link
          to="/bestil-tid"
          className="bg-[#eebb53] hover:bg-[#dca63d] text-white text-xs sm:text-sm font-bold py-2 px-4 rounded-full flex items-center gap-1.5 transition-colors shadow-md"
        >
          <Calendar className="w-3.5 h-3.5" />
          Book tid online
        </Link>
      </div>
    </div>
  )
}

export default App
